export enum BoostReasonEnum {
    LOYALTY = 'LOYALTY',
    CUSTOM_CODE = 'CUSTOM_CODE',
    UTMB_GO = 'UTMB_GO',
}
